//import BusinessUnits from './screens/index.vue';
const BusinessUnits = () => import('./screens/index.vue')

import { PERMISSIONS_KEYS } from '@/settings/consts/permissions';
import { checkUserPermissions } from '@/services/auth';

const businessunitsRoutes = [];

if (
  checkUserPermissions([
    PERMISSIONS_KEYS.BUSINESS_UNIT_VIEW,
    PERMISSIONS_KEYS.BUSINESS_UNIT_EDIT,
  ])
) {
  businessunitsRoutes.push({
    path: '/empresas',
    name: 'Cadastro / Consulta|Empresas',
    component: BusinessUnits,
    meta: {
      icon: 'fa-hospital',
      requiresAuth: true,
    },
  });
}

export { businessunitsRoutes };
